import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "children", "dir"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React, { useContext, Children } from 'react';
import './index.js';
import { TextDirectionContext } from './TextDirectionContext.js';
var TextBase = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    children = _ref.children,
    _ref$dir = _ref.dir,
    dir = _ref$dir === void 0 ? 'auto' : _ref$dir,
    rest = _objectWithoutProperties(_ref, _excluded);
  var context = useContext(TextDirectionContext);
  var textProps = {};
  var BaseComponent = as !== null && as !== void 0 ? as : 'span';
  var value = _objectSpread({}, context);
  if (!context) {
    textProps.dir = dir;
    value.direction = dir;
  } else {
    var parentDirection = context.direction,
      getTextDirection = context.getTextDirection;
    if (getTextDirection && getTextDirection.current) {
      var text = getTextFromChildren(children);
      var override = getTextDirection.current(text);
      if (parentDirection !== override) {
        textProps.dir = override;
        value.direction = override;
      } else if (parentDirection === 'auto') {
        textProps.dir = override;
      }
    } else if (parentDirection !== dir) {
      textProps.dir = dir;
      value.direction = dir;
    } else if (parentDirection === 'auto') {
      textProps.dir = dir;
    }
  }
  return /*#__PURE__*/React.createElement(TextDirectionContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(BaseComponent, _extends({
    ref: ref
  }, rest, textProps), children));
});
var Text = TextBase;
Text.propTypes = {
  /**
   * Provide a custom element type used to render the outermost node
   */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.elementType]),
  /**
   * Provide child elements or text to be rendered inside of this component
   */
  children: PropTypes.node.isRequired,
  /**
   * Specify the text direction to be used for this component and any of its
   * children
   */
  dir: PropTypes.oneOf(['ltr', 'rtl', 'auto'])
};
var getTextFromChildren = function getTextFromChildren(children) {
  var _Children$map;
  if (typeof children === 'string') {
    return children;
  }
  var text = (_Children$map = Children.map(children, function (child) {
    if (typeof child === 'string') {
      return child;
    }
    return null;
  })) === null || _Children$map === void 0 ? void 0 : _Children$map.filter(function (text) {
    return text !== null;
  });
  if ((text === null || text === void 0 ? void 0 : text.length) === 1) {
    return text[0];
  }
  return text;
};
export { Text };